import { isDev } from './is-dev.fn';

export async function timer<T>(name: string, fn: () => Promise<T>) {
  if (isDev()) {
    const start = performance.now();
    const result = await fn();
    const end = performance.now();

    console.info(name, end - start);

    return result;
  } else {
    return await fn();
  }
}
